import { createColumnHelper } from '@tanstack/react-table';

import { Location } from 'types/washhub';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<Location>();

export const buildWashHubColumns = () => [
  col.accessor((item) => item?.name || '-', {
    id: 'name',
    header: 'Wash Hub Name',
    minSize: 130,
    size: 160,
  }),
  col.accessor(
    (item) => item?.address?.fullAddress || item?.address?.addressLine1 || '-',
    {
      id: 'address',
      header: 'Address',
      minSize: 280,
      size: 520,
    },
  ),
  col.accessor((item) => (item?.phcMethod === 1 ? ' Stack' : 'Rack'), {
    id: 'phcMethod',
    header: 'Counting Method',
    minSize: 130,
  }),
  col.accessor((item) => convertUTCToLocal(item?.createdAt, true, true), {
    id: 'createdAt',
    header: 'Date Created',
    minSize: 150,
    meta: { align: 'center' },
  }),
  col.accessor((item) => item?.size, {
    id: 'size',
    header: 'Hub Size',
    minSize: 80,
    meta: { align: 'center' },
  }),
];
